/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  Component,
  effect,
  Inject,
  Injector,
  PLATFORM_ID,
  Renderer2,
  signal,
  DOCUMENT,
  inject,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormGroup, FormsModule } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { InitialService } from '../../services/initial.service';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { assets } from '../../core/constants/assets.const';
import { langugaes } from '../../models/common';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe } from '../../core/pipes/translate.pipe';
import { I18nService } from '../../services/i18n.service';
import { ToasterService } from '../../services/toaster.service';
import { persistLanguage } from '../../core/helpers/language-storage.helper';
@Component({
  selector: 'logibids-get-started',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.scss'],
  imports: [
    TranslatePipe,
    FormsModule,
    RouterModule,
    DropdownModule,
    ButtonModule,
  ],
})
export class GetStartedComponent implements AfterViewInit {
  form: FormGroup;

  selectedLang: string = '';
  assetsConst = assets;
  filteredLanguages: langugaes[];
  protected submitted = signal<boolean>(false);
  languages: any;
  private readonly translateService = inject(I18nService);
  private readonly _InitialService = inject(InitialService);
  private readonly toasterService = inject(ToasterService);
  private readonly router = inject(Router);

  constructor(
    private initialService: InitialService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.languages = this.initialService.languages;
    effect(() => {
      if (this.languages() && this.languages().length > 0) {
        this.filteredLanguages = this.languages();
      }
    });
    this.initialService.getLanguages();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const setLang = localStorage.getItem('language');
      if (setLang) {
        this.selectedLang = setLang;
      }
    }
  }

  lang_change(event: DropdownChangeEvent): void {
    if (isPlatformBrowser(this.platformId)) {
      if (event.value) {
        persistLanguage(String(event.value));
        void this.translateService.ensureLoaded(String(event.value));
      }
    }
  }

  private setDirection(lang: string) {
    if (isPlatformBrowser(this.platformId)) {
      const dir = lang === 'ar' ? 'rtl' : 'ltr';

      this.renderer.setAttribute(this.document.documentElement, 'dir', dir);
      this.renderer.setAttribute(this.document.documentElement, 'lang', lang);

      this._InitialService.setUpGoogleScript(lang);

      if (dir === 'rtl') {
        this.renderer.addClass(this.document.body, 'rtl');
      } else {
        this.renderer.removeClass(this.document.body, 'rtl');
      }
    }
  }

  submit() {
    this.submitted.set(true);
    if (isPlatformBrowser(this.platformId)) {
      if (this.selectedLang) {
        persistLanguage(this.selectedLang);
        this.setDirection(this.selectedLang);
        this.router.navigateByUrl('/auth/login');
      } else {
        this.toasterService.showError(
          this.translateService.translate('PleasechooseLang')
        );
      }
    }
  }
}
